export default __webpack_public_path__ + "static/Courier-4f7e1c9e291c3134948f94dd95eca01b.otf";